import axios from "axios";
//import qs from 'qs'
import { HttpRequest } from './request.utils'
import { store } from "Store/store.index";
import { baseUrlApis } from "./index";
import * as API_CONSTANTS from './constants';


//const IDOX_PI_ENGINE_KEY = 'EkSl7EGO12';

export default class IDoxApis extends HttpRequest {
  constructor() {
    super();
    this.CPDFURI = '';
  }
  initialize = () => {
    try {
      baseUrlApis.getBaseUrlBy(API_CONSTANTS.URL_CWS_API).then((data) => {
        this.CPDFURI = data;
        //https://aig.i-demo.idox.ai:8443/
        //this.CPDFURI = 'https://aig.i-demo.idox.ai:8443';
        let axiosClient = axios.create({
          baseURL: this.CPDFURI,
         /*  headers: {
            'iDox-API-Engine-Key': IDOX_PI_ENGINE_KEY
          } */
        });
        super.initialize(axiosClient, () => {
          this.interceptorsFn();
        });
      });
    } catch (error) {
      throw error;
    }
  }
  async checkDocumentType({ content }) {
    /* return {
      "ret": 0,
      "message": "SUCCESS",
      "data": {
        "type": "CONTRACT",
        "subType": "Securities-Purchase-Agreement",
      },
      "returned": 1
    } */
    //https://pheecws-azk8s.foxitcloud.com/cpdfapi/v1/documents/type
    let url = `/cpdfapi/v1/documents/type?access-token=${store.userStore.token}`
    let result = await this.post({ url, data: { content }/* , config  */ });
    return result;
  }
}